<template>
  <div id="app" ref="app">
    <div class="header">
      <div class="logo">
        {{ titles }}
      </div>
      <div class="nav">
        <div class="nav-item" @click="navIndexClick(0)">
          <router-link to="/" class="item_name">首页</router-link>
          <div :class="{ active: navIndex == 0 }"></div>
        </div>
        <div class="nav-item" @click="navIndexClick(1)">
          <router-link to="/about" class="item_name">产品介绍</router-link>
          <div :class="{ active: navIndex == 1 }"></div>
        </div>
        <div class="nav-item" @click="navIndexClick(2)">
          <router-link to="/download" class="item_name">下载中心</router-link>
          <div :class="{ active: navIndex == 2 }"></div>
        </div>
        <div class="nav-item" @click="navIndexClick(3)">
          <router-link to="/myFrom" class="item_name">关于我们</router-link>
          <div :class="{ active: navIndex == 3 }"></div>
        </div>
        <div class="nav-item" @click="navIndexClick(4)">
          <router-link to="/contact" class="item_name">联系我们</router-link>
          <div :class="{ active: navIndex == 4 }"></div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import _ from "lodash";
import DevicePixelRatio from './utils/DevicePixelRatio.js';
import { getCompany, getLeaders, getPartners } from '@/api'

export default {
  name: "App",
  data() {
    return {
      navIndex: 0,
      titles: ''
    }
  },

  mounted() {
    this.init()
    this.navIndex = 0
    this.$nextTick(() => {
      (function () {

        function setRemUnit() {


          const docEl = document.documentElement;


          const width = docEl.clientWidth;


          const rem = width / 100; // 设置1rem为屏幕宽度的1/10


          docEl.style.fontSize = rem + 'px';


        }


        setRemUnit();


        window.addEventListener('resize', setRemUnit);


      })();
    });
  },
  methods: {
    navIndexClick(index) {
      this.navIndex = index
      localStorage.setItem('navIndex', index)
    },
    async init() {
      
      
      try {
        // 方式1：并行请求（推荐，速度更快）
        const [companyRes, leadersRes, partnersRes] = await Promise.all([
          getCompany(),
          getLeaders(),
          getPartners()
        ])
        
        // 处理公司信息
        if (companyRes.code === 1) {
          this.titles = companyRes.data.name
          localStorage.setItem('company', JSON.stringify(companyRes.data))
        }
        
        // 处理领导信息
        if (leadersRes.code === 1) {
          localStorage.setItem('leaders', JSON.stringify(leadersRes.data))
        }
        
        // 处理合作伙伴信息
        if (partnersRes.code === 1) {
          localStorage.setItem('partners', JSON.stringify(partnersRes.data))
        }
        
        console.log('所有数据加载完成')
        
      } catch (error) {
        console.error('初始化数据失败:', error)
        // 可以在这里添加错误处理逻辑
      } 
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16.3rem 0 2.14rem;
  box-sizing: border-box;
  height: 3rem;
  margin-top: 0.99rem;
  z-index: 10;

  .logo {
    height: 3rem;
    font-size: 1.69rem;
    color: #FFFFFF;
    line-height: 3rem;
  }

  .nav {
    display: flex;
    align-items: center;
    gap: 3.13rem;

    .nav-item {
      height: 1.09rem;
      font-weight: 600;
      font-size: 0.78rem;
      color: #FFFFFF;
      line-height: 1.09rem;

      .item_name {
        color: #FFFFFF;

      }

      .active {
        margin: 0 auto;
        width: 1.01rem;
        height: 0.25rem;
        border-radius: 0.13rem;
        background: #FFFFFF;
      }

      &:hover {
        color: #FFFFFF;
      }
    }
  }
}

/* 移除所有 <a> 标签的下划线 */
a {
  text-decoration: none;
}

/* 移除激活状态的 router-link 的下划线 */
router-link-active {
  text-decoration: none;
}
</style>
